import { QuestionBase } from './question-base.model';

export class HtmlEditorQuestion extends QuestionBase<string> {
   controlType = 'html-editor';
   type: string;
   modules: any;
   placeholder: string;
   style: any;
   format: string;
   disabled: boolean;
   visible: boolean;
   config: any;
   customConfig: boolean;
   maxlength:any
   macro_datasource: any;

   constructor(options: {} = {}) {
      super(options);
      this.type = options['type'] || '';
      this.modules = options['modules'] || null;
      this.placeholder = options['placeholder'] || '';
      this.style = options['style'] || null;
      this.format = options['format'] || '';
      this.disabled = (options['disabled'] == undefined) ? false : options['disabled'];
      // this.visible = options['visible'] || true;
      this.visible = (options['visible'] == undefined) ? true : options['visible'];
      this.config = options['config'];
      this.customConfig = options['customConfig'] || false;
      this.maxlength = options['maxlength'] || null;
      this.macro_datasource =  (options['macro_datasource'] == undefined) ? false : options['macro_datasource'];
   }
}